import { FC, memo } from "react";
import { StyleSheet } from "react-native";
import { View, Text } from "@src/components";
import { Image } from "expo-image";
import { Icon } from "@src/components/Icon";
import { useUnistyles } from "react-native-unistyles";

type OfflineSnapshotOverlayProps = {
  snapshotUrl: string;
  snapshotCacheKey: string;
  playerWidth: number;
  playerHeight: number;
  onSnapshotError: () => void;
};

export const OfflineSnapshotOverlay: FC<OfflineSnapshotOverlayProps> = memo(
  ({ snapshotUrl, snapshotCacheKey, playerWidth, playerHeight, onSnapshotError }) => {
    const { theme } = useUnistyles();

    return (
      <View flex={1} bg="black">
        <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
          <View style={{ width: playerWidth, height: playerHeight }}>
            <Image
              source={{ uri: snapshotUrl, cacheKey: snapshotCacheKey } as any}
              style={StyleSheet.absoluteFillObject}
              contentFit="cover"
              cachePolicy="memory-disk"
              onError={onSnapshotError}
            />
            <View
              style={{
                ...StyleSheet.absoluteFillObject,
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
              }}
            >
              <Icon
                name="errorOutline"
                size={48}
                color={theme.colors.white.default}
                style={{ marginBottom: theme.spacing.lg }}
              />
              <Text textStyle="md/regular" style={{ color: theme.colors.white.default, textAlign: "center" }}>
                Offline — unable to start stream
              </Text>
            </View>
          </View>
        </View>
      </View>
    );
  },
);

OfflineSnapshotOverlay.displayName = "OfflineSnapshotOverlay";
